import React, {useEffect, useState} from "react";
import {Box, Button, Modal, Typography} from "@mui/material";

import {makeStyles} from "@mui/styles";
import {ClosePopupBtn} from "../../../../../../../com/closePopupBtn/closePopupBtn";
import {SortBtn} from "../../../../../../com/sortBtn/sortBtn";
import {ConfigDto} from "../../../../../../flippingFlyersCatalog/flippingFlyerTocTab";
import {FlyerClassDto} from "../../../../../../../dtos";
import {FlyerClass} from "./flyerClass";
import {CreateEditFlyerClassPopup} from "./createEditFlyerClassPopup";
import {getFlyerClasses} from "../../../../../../../store/actionCreators/flyerClassesActionCreators";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";

const useStyles = makeStyles(() => ({
    flyerClassesWrapper: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "20vw",
        minWidth: "322px",
        backgroundColor: "white",
        height: "70vh",
        display: "flex",
        flexFlow: "column"

    },
    flyerClassesHeader: {
        position: "relative",
        padding: `12px 20px`,
        background: `linear-gradient(89.41deg, #0198D2 0%, #3540A8 100%)`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .MuiButton-root": {
            "& > svg": {
                "& > path": {
                    fill: `#ffffff`,
                },
            },
        },
    },
    newFlyerClassBtnWrap: {
        display: "flex",
        justifyContent: "center",
        padding: "8px"

    },
    flyerClassesContentHeader: {
        display: "flex",
        flexFlow: "row",
        justifyContent: "space-between",
        padding: "8px 12px",
        backgroundColor: "#E9EEFF"
    },
}))

interface Props {
    show: boolean;
    onHide: VoidFunction;

}


export const FlyerClassesPopup: React.FC<Props> = ({
                                                      show,
                                                      onHide
                                                  }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const flyerClasses = useTypedSelector((state) => state.flyerClasses);
    const [flyerClassesState, setFlyerClassesState] = useState<FlyerClassDto[]>([]);
    const [sortConfig, setSortConfig] = useState<ConfigDto | null>(null);
    const [isShowCreateEditPopup, setIsShowCreateEditPopup] = useState<boolean>(false);
    const [flyerClassData, setFlyerClassData] = useState<FlyerClassDto>({
        caption: "",
        id: "",
        accountId: 0
    });
    const [isNewFlyerClass, setNewFlyerClass] = useState<boolean>(false);

    useEffect(() => {
        dispatch(getFlyerClasses());
    }, []);

    useEffect(() => {
        setFlyerClassesState(flyerClasses.flyerClasses);
    }, [flyerClasses.flyerClasses])

    useEffect(() => {
        if (sortConfig) {
            let sortableItems = [...flyerClassesState];
            sortableItems.sort((a, b) => {
                if (a[sortConfig.caption as keyof FlyerClassDto].toString().toLowerCase() < b[sortConfig.caption as keyof FlyerClassDto].toString().toLowerCase()) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.caption as keyof FlyerClassDto].toString().toLowerCase() > b[sortConfig.caption as keyof FlyerClassDto].toString().toLowerCase()) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
            setFlyerClassesState(sortableItems);
        }
    }, [sortConfig]);


    const createNewFlyerClass = () => {
        setFlyerClassData({
            caption: "",
            id: "",
            accountId: 0
        });
        setNewFlyerClass(true);
        setIsShowCreateEditPopup(true);
    }

    const editNewFlyerClass = (fyerClass: FlyerClassDto) => {
        setFlyerClassData(fyerClass);
        setNewFlyerClass(false);
        setIsShowCreateEditPopup(true);
    }

    const flyerClassesArray = flyerClassesState.map((data, index) => {
        return <FlyerClass key={index} flyerClassData={data} editNewFlyerClass={editNewFlyerClass}/>
    });

    return (
        <>
            <Modal open={show}>
                <Box className={classes.flyerClassesWrapper}>
                    <Box
                        className={classes.flyerClassesHeader}
                    >
                        <Box>
                            <Typography color={`#ffffff`} fontWeight={700}>
                                Flyer Classes
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: `flex`,
                            justifyContent: `flex-end`,
                            position: "absolute",
                            top: "50%",
                            right: "5px",
                            transform: "translateY(-50%)"
                        }}>
                            <ClosePopupBtn onClose={onHide}/>
                        </Box>
                    </Box>
                    <Box
                        className={classes.newFlyerClassBtnWrap}
                    >
                        <Button
                            onClick={createNewFlyerClass}
                            sx={{
                                padding: "8px 12px",
                                background: "linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)",
                                borderRadius: "2px"
                            }}
                            disableFocusRipple
                        >
                            <Typography
                                color={"#FFFFFF"}
                                fontWeight={700}
                                fontSize={"14px"}
                            >
                                + New Flyer Class
                            </Typography>
                        </Button>
                    </Box>
                    <Box
                        className={classes.flyerClassesContentHeader}
                    >
                        <Typography>
                            Flyer classes
                        </Typography>
                        <SortBtn sortCaption={"caption"} sortConfig={sortConfig} setSortConfig={setSortConfig} items={flyerClassesState}/>
                    </Box>
                    <Box
                        sx={{
                            flex: "1 1 auto",
                            overflow: "auto"
                        }}
                    >
                        {flyerClassesArray}
                    </Box>
                </Box>
            </Modal>
            {isShowCreateEditPopup &&
                <CreateEditFlyerClassPopup show={isShowCreateEditPopup} isNew={isNewFlyerClass} flyerClassData={flyerClassData}
                                           hide={() => {
                                               setIsShowCreateEditPopup(false);
                                           }}
                />
            }
        </>
    )
}